import React, { forwardRef } from 'react';

/**
 * The heading at the top of each wizard step: 20px bold gray/900, with the
 * 13px gray/650 line under it where the step has one.
 *
 * It takes focus when the step changes (see `pages/QuestionBank`), so a
 * keyboard or screen-reader user lands on the new step rather than on a button
 * that has just been swapped out from under them.
 */
const StepHeading = forwardRef(({ title, lead, children }, ref) => (
    <div className="tw-flex tw-flex-col tw-items-start tw-text-start">
        <h2
            ref={ref}
            tabIndex={-1}
            className="tw-m-0 tw-text-[18px] tw-font-bold tw-leading-[1.5] tw-text-v2-neutral-900 focus:tw-outline-none md:tw-text-[20px]"
        >
            {title}
        </h2>
        {lead && <p className="tw-m-0 tw-pt-[4px] tw-text-[13px] tw-leading-[1.6] tw-text-v2-text-excerpt">{lead}</p>}
        {children}
    </div>
));

export default StepHeading;
